
import IqosLogo from '~/assets/img/icons/IqosLogo';

export default {
	name: 'Nav',
	components: { IqosLogo },
};
